<span *ngIf="!data.warn" class="success-icon"><mat-icon>check_circle</mat-icon></span>
<span *ngIf="data.warn" class="warn-icon"><mat-icon>cancel</mat-icon></span>
<span [ngClass]="data.warn ? 'snack-bar_content content-warning' : 'snack-bar_content content-success'" class="snack-bar_content" matSnackBarLabel>
    {{data.content}}
</span>
<span [ngClass]="data.warn? 'snack-bar_close snack-bar-warning' : 'snack-bar_close snack-bar-success'" matSnackBarActions>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()"><mat-icon>close</mat-icon></button>
</span>